import React, { useEffect, useState } from 'react';
import { Toaster } from 'react-hot-toast';
import { AdvancedFiltersMainWrapper, getUrlQueryParam, Product, standaloneExternalContext }
  from '@access-erp/common';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { EnquiriesApplicationModule } from '@/components/common/EnquiriesScreen/EnquiriesApplicationModule';
import { ContractsExternalContext } from '@/components/common/EnquiriesScreen/utils/enquiriesSettings';
import { getSubscriptionId } from '@/utils/auth/subscription.utils';
import { getAccessToken } from '@/utils/auth/token.utils';
import ProductsComponent from './ProductsComponent';
import { appSettings } from '@/utils/microfrontend/appSettingsForEnquiriesScreen';

export default function PurchaseOrdersModule(): React.JSX.Element {
  const [subscriptionId, setSubscriptionId] = useState<string>();

  useEffect(() => {
    const getSubId = async () => {
      const subId = await getSubscriptionId();
      setSubscriptionId(subId!);
    };

    getSubId();
  }, []);

  const externalContext: ContractsExternalContext = {
    ...standaloneExternalContext,
    product: Product.ContractsAndBilling,
    getIdentityToken: async () => getAccessToken(),
    refetchToken: async () => getUrlQueryParam('token') ?? '',
    getAccessWorkspaceInstanceId: () => subscriptionId!,
    preloadedData: {},
  };

  return (
    <EnquiriesApplicationModule
      externalContext={externalContext}
      appSettings={appSettings}
      pageName="Purchase Orders"
      suppressIntercom={true}
      apolloClient={apolloClientContracts}
    >
      <AdvancedFiltersMainWrapper>
        <ProductsComponent />
        <Toaster />
      </AdvancedFiltersMainWrapper>
    </EnquiriesApplicationModule>
  );
}
